import common from '../../strings/common.json';

export const setEmptyValidityMessage = (e: any) => {
  e.target.setCustomValidity(common.emptyField);
};

export const resetValidity = (e: any) => {
  e.target.setCustomValidity('');
};
